const shadows = {
  smallShadow: '0px 2px 4px rgba(82, 38, 153, 0.06)',
  normalShadow: '0px 4px 8px rgba(82, 38, 153, 0.06)',
  mediumShadow: '0px 8px 16px rgba(82, 38, 153, 0.04)',
  largeShadow: '0px 16px 32px rgba(82, 38, 153, 0.04)',
  light: '0 2px 1px -1px #00000003, 0 1px 1px #00000003, 0 1px 3px #0000001a'
};

export default shadows;
